var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{class:[
    'header bg-' + _vm.variant,
    { 'sticky-top': _vm.sticky },
    { shadow: _vm.shadow },
  ]},[_c('div',{staticClass:"container"},[_c('nav',{class:[
        'navbar justify-content-between',
        _vm.expandClass,
        _vm.isDarkTheme ? 'navbar-dark' : 'navbar-light',
      ]},[_c('SiteLogoBS46',{staticClass:"navbar-brand"}),_c('router-link',{staticClass:"navbar-toggler btn-icon-square d-lg-none",attrs:{"to":"/account","role":"button"}},[_c('span',{staticClass:"material-icons"},[_vm._v("person")])]),_c('div',{attrs:{"id":"navbarCollapse"}},[_c('ul',{staticClass:"nav navbar-nav d-none d-lg-block"},[(_vm.showPersonalCabinet)?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/account"}},[_vm._v("Личный кабинет")])],1):_vm._e()])])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }